import { Component } from '@angular/core';
import { Breadcrumb } from 'src/app/page-header/component/page-header.component';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    standalone: false
})
export class ServicesComponent {
  heading = 'Services';
  description: Array<string> = ['Services and some of the technologies we use.'];
  breadcrumbs: Array<Breadcrumb> = [{
    link: '/home',
    ariaLabel: 'Go back to home page',
    label: 'Home'
  }, {
    link: '',
    ariaLabel: '',
    label: 'Services'
  }];
}
